import { render, staticRenderFns } from "./IConfirmationDialog.vue?vue&type=template&id=bd85589c&"
import script from "./IConfirmationDialog.vue?vue&type=script&lang=js&"
export * from "./IConfirmationDialog.vue?vue&type=script&lang=js&"
import style0 from "./IConfirmationDialog.vue?vue&type=style&index=0&id=bd85589c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports